import { isProd } from '@/shared/utils'
import { isCurrentTimeInRange } from '@/utils/date'

// production
export const GLASSIS_TEASER_OPEN_TIME = '2025-06-23 12:00'
export const GLASSIS_TEASER_END_TIME = '2025-06-30 18:00'
export const GLASSIS_MAIN_OPEN_TIME = '2025-07-01 08:00'

// staging
export const STAGING_GLASSIS_TEASER_OPEN_TIME = '2025-06-23 10:00'
export const STAGING_GLASSIS_MAIN_OPEN_TIME = '2025-06-30 11:30'

export const isGlassisMainPeriod = () =>
  isProd
    ? isCurrentTimeInRange({
        from: GLASSIS_MAIN_OPEN_TIME,
      })
    : true

// Glassis Main Event
export const GLASSIS_MAIN_EVENT_OPEN_TIME = '2025-07-01 08:00'
export const GLASSIS_MAIN_EVENT_END_TIME = '2025-08-04 13:00'
export const isGlassisMainEventPeriod = () =>
  isProd
    ? isCurrentTimeInRange({
        from: GLASSIS_MAIN_EVENT_OPEN_TIME,
        to: GLASSIS_MAIN_EVENT_END_TIME,
      })
    : true

// 한국 관광 공사 캠페인 https://healingpaper.slack.com/archives/C027T02M1L6/p1750729836621329?thread_ts=1750672013.419239&cid=C027T02M1L6
const KOREA_TOURISM_CAMPAIGN_OPEN_TIME = '2025-07-01 08:00'
const KOREA_TOURISM_CAMPAIGN_END_TIME = '2025-10-31 23:59'
export const isKoreaTourismCampaignPeriod = () =>
  isProd
    ? isCurrentTimeInRange({
        from: KOREA_TOURISM_CAMPAIGN_OPEN_TIME,
        to: KOREA_TOURISM_CAMPAIGN_END_TIME,
      })
    : true
